export default __webpack_public_path__ + "static/image9-eec86e413275ca8b08fc03df6957e555.gif";